import { Stack } from "@phosphor-icons/react";
import { SettingsCrud } from "./SettingsCrud";

export function DepartmentsSettings() {
  return (
    <SettingsCrud
      testid="departments"
      title="Departments"
      icon={Stack}
      description="Functional groups in your organization (e.g. Operations, Sales). Used when assigning users and positions."
      endpoint="/departments"
      meta={(d) => (d.user_count ? `${d.user_count} user${d.user_count > 1 ? "s" : ""}` : "")}
      subtitle={(d) => d.code || ""}
      fields={[
        { name: "name", label: "Department name", type: "text", required: true, placeholder: "e.g. Operations" },
        { name: "code", label: "Code", type: "text", placeholder: "e.g. OPS" },
      ]}
    />
  );
}

export default DepartmentsSettings;
